export default __webpack_public_path__ + "static/media/icons8_1st_place_medal_1 1.0175b5df.svg";